import React from 'react'
import { H3, H5 } from '../Heading/index'

/**
 * The gaia plus intro tiles component
 * @param {Object} props - The props
 * @param {String} props.sectionId - The id of PM section
 * @param {String} props.language - The user's language
 * @param {Map} props.pmSection - The PM sections data
 * @param {Map} props.faqs - The faq items data
 * @returns {JSX.Element} The intro tiles component
 */

function GaiaPlusFaq (props) {
  const {
    sectionId,
    pmSection,
    language,
    faqs,
  } = props

  if (!sectionId || !pmSection.size || !faqs.size) {
    return null
  }

  const section = pmSection.get(sectionId)
  const headerLabel = section.getIn(['data', 'data', 'header', 'label'])

  return (
    <div className="gaia-plus-page__faq">
      <div className="gaia-plus-page__faq-container">
        <H3>{headerLabel}</H3>
        {faqs.valueSeq().map((faq) => {
          const id = faq.getIn([language, 'data', 'id'])
          const title = faq.getIn([language, 'data', 'title'])
          const teaser = faq.getIn([language, 'data', 'teaser'])
          const isProcessing = faq.getIn([language, 'processing'])
          return isProcessing ? null : (
            <div key={id} className="gaia-plus-page__faq-item">
              <H5>{title}</H5>
              <p>{teaser}</p>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default GaiaPlusFaq
